module.exports = __webpack_public_path__ + "img/secunet.12c717b2.png";